
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.css'],
    standalone: true,
    imports: [TranslateModule]
})
export class ModalComponent {
    @Input() isOpen: boolean = false;
    @Input() title: string = '';

    @Output() close = new EventEmitter<void>();

    onClose(): void {
        this.close.emit();
    }

    onModalClick(event: MouseEvent): void {
        event.stopPropagation();
    }
}